import React, {useState, useEffect, useContext} from "react";
import Table from "../../../components/table/Tables";
import AppLoader, {LoadComponet} from "../../../components/loaders/Loader";
import ShowCourseModal from "./ShowCourseModal";
import DeleteModal from "../../../components/modals/DeleteModal";
import {EmblemContext} from "../../../context/EmblemProvider";
import {useHistory} from "react-router-dom";
import {DeleteCourse} from "../../../services/CoursesServices";
import {PageWebUrl} from "../../../services/ApiUrl";

export default function CoursesList({theme, isLoading, data, toggleChange, deleteItem}) {
   const {getExperiences, experiencesList, dlExperiences, toggleExperiences, isSaving} = useContext(EmblemContext);
   const [showModal, setShowModal] = useState({isOpen: false, data: {}});

   let history = useHistory();
   const [deleteModal, setDeleteModal] = useState({isOpen: false, id: "", url: ""});

   useEffect(() => {
      getExperiences();
   }, []);

   const saveDelete = () => {
      dlExperiences(deleteModal.id);
      setDeleteModal({isOpen: false, data: {}, id: "", url: ""});
   };

   return (
      <>
         {isLoading ? (
            <LoadComponet isVisible={true} theme={theme} />
         ) : (
            <Table
               theme={theme}
               data={experiencesList}
               toggleChange={toggleExperiences}
               showModal={(course) => {
                  let info = {...course};
                  setShowModal({isOpen: true, data: info, type: "info", title: "Información De curso esencial"});
               }}
               deleteModal={(course) => {
                  setDeleteModal({isOpen: true, id: course.idCourse, url: "google.com"});
               }}
               viewAction={(item) => {
                  let newxtUrl = PageWebUrl + "programa_emblem/";
                  window.open(newxtUrl, "_blank");
               }}
               editModal={(item) => {
                  history.push(`/offer/edit/${item.idCourseType}/${item.idCourse}`, {prev: "/offer/programa_emblem"});
               }}
               columns={Columns}
            />
         )}
         <ShowCourseModal
            isOpen={showModal.isOpen}
            close={() => {
               setShowModal(false);
            }}
            theme={theme}
            type={showModal.type}
            title="Información de Programa Emblem"
            data={showModal.data}
         />
         <DeleteModal
            isOpen={deleteModal.isOpen}
            close={() => {
               setDeleteModal({isOpen: false, data: {}, id: "", url: ""});
            }}
            theme={theme}
            confirm={saveDelete}
         />
         <AppLoader isVisible={isSaving} />
      </>
   );
}

const Columns = [
   {
      title: "Nombre",
      accessor: "courseName",
      action: "show",
   },
   {
      title: "Facilitadores",
      accessor: "facilitator",
   },
   {
      title: "Código de curso",
      accessor: "courseCode",
   },
   {
      title: "Fecha de inicio",
      accessor: "startDate",
   },
   /* {
      title: "Añadir a Home",
      class: "actionBtn ghost",
      component: "toggle",
      accessor: "onhome",
   },
   {
      title: "Añadir a la página",
      class: "actionBtn ghost",
      component: "toggle",
      ac cessor: "onpage",
   },*/
   {
      title: "Vista en página",
      class: "actionBtn ghost",
      component: "view",
   },
   /*  {
      title: "",
      class: "actionBtn ghost",
      component: "show",
   }, */
   {
      title: "",
      class: "actionBtn ghost",
      component: "edit",
   },
   {
      title: "",
      class: "actionBtn ghost",
      component: "delete",
   },
];
